import React from 'react';
import styled from 'styled-components';

interface AdminFormPageProps {
  children: React.ReactNode;
}

export default function AdminFormPage({ children }: AdminFormPageProps) {
  return (
    <PageWrapper>
      <ContentContainer>
        {children}
        <BottomSpacer />
      </ContentContainer>
    </PageWrapper>
  );
}

const PageWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 32px;
  overflow-y: auto;
  background: white;
  height: 100%;
`;

const ContentContainer = styled.div`
  width: 100%;
  max-width: 640px;
`;

const BottomSpacer = styled.div`
  height: 64px;
  flex-shrink: 0;
`;
